import type { InvoiceDisplayStatus } from "@/domain/types";
import { cn } from "@/lib/cn";

const labels: Record<InvoiceDisplayStatus, string> = {
  draft: "Draft",
  sent: "Sent",
  overdue: "Overdue",
  paid: "Paid",
  void: "Void",
};

const styles: Record<InvoiceDisplayStatus, string> = {
  draft: "bg-surface-muted text-ink-muted",
  sent: "bg-brand-50 text-brand-700",
  overdue: "bg-danger-50 text-danger-700",
  paid: "bg-brand-100 text-brand-800",
  void: "bg-ink/8 text-ink-muted",
};

export function StatusBadge({ status, className }: { status: InvoiceDisplayStatus; className?: string }) {
  return <span className={cn("inline-flex items-center rounded-full px-2.5 py-1 text-xs font-bold", styles[status], className)}>{labels[status]}</span>;
}
